import React from "react";
import {sleep} from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.min.css'
import {GetSelected} from "../../../../common/tableHandler/manipulateTable";
import {InitiateProcessAction} from "../../../../../api/omnimap/omnimapActions";
import {MAN_MU_CONST} from "../../../../../constants/ActionEnums/ManActionEnums";


class CorrectiefOnderhoud extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // warnBudget: false,
            warnOrganisation: false,
            warnWorkPlan: false,
            warnMeasures: false,
            warnEndPeriod: false,
            warnBeginPeriod: false,
            disableButton: true,
            endPeriodValue: null,
            beginPeriodValue: null
        };
    }

    lastUsedTable = [];

    async handleChange(event) {
        let def, divId, nameId, pageNumber;
        switch (typeof event === 'string' ? event : event.target.id) {
            case "maatregel-zoeken-input":
                def = [process.env.REACT_APP_CATALOG_MEASURES];
                divId = "maatregel-grp-maintenance";
                nameId = "maatregel";
                pageNumber = window.$mm_management_maatregelPageNUmber;
                this.setState({
                    warnMeasures: false,
                });
                break;
            case "werkplan-zoeken-input":
                def = [process.env.REACT_APP_CATALOG_WORK_PLANS];
                divId = "werkplan-grp";
                nameId = "werkplan";
                pageNumber = window.$mm_management_werkplanPageNUmber;
                this.setState({
                    warnWorkPlan: false,
                });
                break;
            // case "budget-zoeken-input":
            //     def = [process.env.REACT_APP_CATALOG_BUDGET];
            //     divId = "budget-grp";
            //     nameId = "budget";
            //     pageNumber = window.$mm_management_budgetPageNUmber;
            //     this.setState({
            //         warnBudget: false,
            //     });
            //     break;
            case "organisatie-zoeken-input":
                def = [process.env.REACT_APP_USER_ORGANISATION];
                divId = "organisatie-grp";
                nameId = "organisatie";
                pageNumber = window.$mm_management_organisatiePageNUmber;
                this.setState({
                    warnOrganisation: false,
                });
                break;
            case "beheereenheid_end":
                this.setState({
                    warnEndPeriod: false,
                });
                break;
            case "beheereenheid_begin":
                this.setState({
                    warnBeginPeriod: false,
                });
                break;
            default:
                break;
        }
        const model = {
            content: [
                {
                    key: "algemeen-actief",
                    and_or: "AND",
                    values: [true],
                    datatype: "BOOLEAN",
                },
            ],
            definitions: def,
            text_search: [],
            sorting: [],
        };
        if (typeof event !== 'string'){
            if (event.target?.id === "organisatie-zoeken-input") {
                model.content.push({
                    key: "algemeen-isuitvoerder",
                    and_or: "AND",
                    values: [],
                    datatype: "BOOLEAN",
                });
            }
            if (event.target?.value) {
                model.text_search = [
                    {
                        text_query: event.target.value,
                        search_fields: ["NAME", "IDENTIFIER", "IDENTIFICATION"],
                        fuzzy: true,
                        and_or: "OR",
                    },
                ];
                model.sorting = [{ sort_type: "text_score", direction: "DESCENDING" }];
            }
        }
        let result = await omnimap.FillTableAction(
          model,
          1,
          window.$mm_management_units_token
        );
        CallBackFunctions.GrpCallBack(divId, nameId, result, 0);
    }

    setAllWarnFalse() {
        this.setState({
            // warnBudget: false,
            warnOrganisation: false,
            warnWorkPlan: false,
            warnMeasures: false,
            warnEndPeriod: false,
            warnBeginPeriod: false,
            validated: false
        })
    }

    validateNecessaryFields() {
        const a = this.state.beginPeriodValue;
        if (!this.state.beginPeriodValue) {
            return false
        }
        if (!this.state.endPeriodValue) {
            return false
        }
        return $("input[name=maatregel]:checked")[0]?.defaultValue;
    }

    handleBeforeSubmit() {
        this.setAllWarnFalse()

        let validated = true
        // const time = "T21:00:00.000Z"

        const measure = $("input[name=maatregel]:checked")[0]?.defaultValue
        if (!measure) {
            validated = false
            this.setState({
                warnMeasures: true
            })
        }
        const workPlan = $("input[name=werkplan]:checked")[0]?.defaultValue
        // if (!workPlan) {
        //   validated = false
        //   this.setState({
        //   warnWorkPlan: true
        //   })
        // }

        // const budget = $("input[name=budget]:checked")[0]?.defaultValue

        // if (!budget) {
        //   validated = false
        //   this.setState({
        //   warnBudget: true
        //   })
        // }

        const organisation = $("input[name=organisatie]:checked")[0]?.defaultValue
        // if (!organisation) {
        //   validated = false
        //   this.setState({
        //   warnOrganisation: true
        //   })
        // }
        const beginPeriod = this.state.beginPeriodValue
        if (!beginPeriod) {
            validated = false
            this.setState({
                warnBeginPeriod: true
            })
        }
        const endPeriod = this.state.endPeriodValue
        if (!endPeriod) {
            validated = false
            this.setState({
                warnEndPeriod: true
            })
        }

        if (validated) {
            const period = [
                beginPeriod.toISOString(),
                endPeriod.toISOString(),
            ]

            this.handleSubmit(measure, workPlan, organisation, period)
        } else {
            this.setState({
                disableButton: true
            })
        }
    }

    handleSubmit(measure, workPlan, organisation, period) {
        $("#cover-spin").show(0);

        const model = {
            action: MAN_MU_CONST.CREATE_CORRECTIVE_MAINTENANCE,
            "maatregel_identification": measure,
            "werkplan_identification": workPlan,
            "uitvoerder_identification": organisation,
            "period": period,
            identifications: GetSelected()
        }

        InitiateProcessAction(model, MAN_MU_CONST.END_POINT).then(()=>{
            this.correctiefCallBack()
        }).catch(()=>{
            alert('Something went wrong!')
            $("#cover-spin").hide(0);
        })

        // StartActivity(
        //     model,
        //     selectedIds,
        //     "08dd5290-f3bb-44f8-8331-6501d0ed6f2a",
        //     this.correctiefCallBack,
        //     window.$mm_management_units_token
        // );
    }

    correctiefCallBack() {
        sleep(500).then(() => {
            $("#correctief_onderhoud").modal("hide");
            $("#cover-spin").hide(0);
        });
    }

    componentDidMount() {
        var that = this;

        $("#correctief_onderhoud").on("show.bs.modal", async function (event) {
            var selectedIds = [];

            //   $("#example")
            //     .dataTable()
            //     .$("tr.selected")
            //     .each(function () {
            //       selectedIds.push($(this).attr("rowId"));
            //     });
            var model = {
                content: [
                    {
                        key: "algemeen-actief",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN",
                    },
                ],
                definitions: [process.env.REACT_APP_CATALOG_MEASURES],
            };
            let resultMeasures = await omnimap.FillTableAction(
                model,
                1,
                window.$mm_management_units_token
            );
            CallBackFunctions.GrpCallBack(
                "maatregel-grp-maintenance",
                "maatregel",
                resultMeasures
            );
            model.definitions = [process.env.REACT_APP_CATALOG_WORK_PLANS];
            let resultWorkPlans = await omnimap.FillTableAction(
                model,
                1,
                window.$mm_management_units_token
            );
            CallBackFunctions.GrpCallBack(
                "werkplan-grp",
                "werkplan",
                resultWorkPlans
            );
            model.definitions = [process.env.REACT_APP_CATALOG_BUDGET];
            let resultBudget = await omnimap.FillTableAction(
                model,
                1,
                window.$mm_management_units_token
            );
            CallBackFunctions.GrpCallBack("budget-grp", "budget", resultBudget);

            //asdasdas
            var organisatieModel = {
                content: [
                    {
                        key: "algemeen-actief",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN",
                    },
                    {
                        key: "algemeen-isuitvoerder",
                        and_or: "AND",
                        values: [],
                        datatype: "BOOLEAN",
                    },
                ],
                definitions: [process.env.REACT_APP_USER_ORGANISATION],
            };
            let resultOrganisatie = await omnimap.FillTableAction(
                organisatieModel,
                1
            );
            CallBackFunctions.GrpCallBack(
                "organisatie-grp",
                "organisatie",
                resultOrganisatie
            );
        });

        /***MODAL SCROLL END OF BOTTOM***/
        $("#maatregel-grp-maintenance").scroll(async function () {
            var model = {
                content: [
                    {
                        key: "algemeen-actief",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN",
                    },
                ],
                definitions: [process.env.REACT_APP_CATALOG_MEASURES],
            };
            var buffer = 2; // # of pixels from bottom of scroll to fire your function. Can be 0
            if (
                $("#maatregel-grp-maintenance").prop("scrollHeight") -
                $("#maatregel-grp-maintenance").scrollTop() <=
                $("#maatregel-grp-maintenance").height() + buffer
            ) {
                let result = await omnimap.FillTableAction(
                    model,
                    window.$mm_management_maatregelPageNUmber++,
                    window.$mm_management_units_token
                );
                CallBackFunctions.GrpCallBack(
                    "maatregel-grp-maintenance",
                    "maatregel",
                    result,
                    window.$mm_management_maatregelPageNUmber
                );
            }
        });
        $("#werkplan-grp").scroll(async function () {
            var model = {
                content: [
                    {
                        key: "algemeen-actief",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN",
                    },
                ],
                definitions: [process.env.REACT_APP_CATALOG_WORK_PLANS],
            };
            var buffer = 2; // # of pixels from bottom of scroll to fire your function. Can be 0

            if (
                $("#werkplan-grp").prop("scrollHeight") -
                $("#werkplan-grp").scrollTop() <=
                $("#werkplan-grp").height() + buffer
            ) {
                window.$mm_management_maatregelPageNUmber++;
                let result = await omnimap.FillTableAction(
                    model,
                    window.$mm_management_werkplanPageNUmber++,
                    window.$mm_management_units_token
                );
                CallBackFunctions.GrpCallBack("werkplan-grp", "werkplan", result);
            }
        });
        // $("#budget-grp").scroll(async function () {
        //     var model = {
        //         content: [
        //             {
        //                 key: "algemeen-actief",
        //                 and_or: "AND",
        //                 values: [true],
        //                 datatype: "BOOLEAN",
        //             },
        //         ],
        //         definitions: [process.env.REACT_APP_CATALOG_BUDGET],
        //     };
        //     var buffer = 2; // # of pixels from bottom of scroll to fire your function. Can be 0
        //
        //     if (
        //         $("#budget-grp").prop("scrollHeight") - $("#budget-grp").scrollTop() <=
        //         $("#budget-grp").height() + buffer
        //     ) {
        //         window.$mm_management_maatregelPageNUmber++;
        //         let result = await omnimap.FillTableAction(
        //             model,
        //             window.$mm_management_budgetPageNUmber++,
        //             window.$mm_management_units_token
        //         );
        //         CallBackFunctions.GrpCallBack("budget-grp", "budget", result);
        //     }
        // });
        $("#organisatie-grp").scroll(async function () {
            var model = {
                content: [
                    {
                        key: "algemeen-actief",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN",
                    },
                    {
                        key: "algemeen-isuitvoerder",
                        and_or: "AND",
                        values: [],
                        datatype: "BOOLEAN",
                    },
                ],
                definitions: [process.env.REACT_APP_USER_ORGANISATION],
            };
            var buffer = 2; // # of pixels from bottom of scroll to fire your function. Can be 0

            if (
                $("#organisatie-grp").prop("scrollHeight") -
                $("#organisatie-grp").scrollTop() <=
                $("#organisatie-grp").height() + buffer
            ) {
                window.$mm_management_organisatiePageNUmber++;
                let result = await omnimap.FillTableAction(
                    model,
                    window.$mm_management_organisatiePageNUmber++,
                    window.$mm_management_units_token
                );
                CallBackFunctions.GrpCallBack("organisatie-grp", "organisatie", result);
            }
        });
    }

    render() {
        return (
            <div
                className="modal fade"
                tabIndex={-1}
                role="dialog"
                id="correctief_onderhoud"
                onClick={() => {
                    // Change activity state of button
                    this.setState({
                        disableButton: !this.validateNecessaryFields()
                    })
                }}
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Correctief onderhoud</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <div class="btn-plannig-context">
                                <h2>Periode:</h2>

                                <p>Begin</p>
                                {this.state.warnBeginPeriod &&
                                    <p className="red-text">Geselecteerd: Niets geselecteerd</p>}
                                <DatePicker
                                    selected={this.state.beginPeriodValue}
                                    onChange={(date: Date) => {
                                        this.setState({beginPeriodValue: date})
                                        this.handleChange('beheereenheid_begin')
                                    }}
                                    dateFormat='dd/MM/yyyy'
                                    id="beheereenheid_begin"
                                    className="form-control"
                                    placeholderText="Horizon Begin"
                                />
                                <p>Einde</p>
                                {this.state.warnEndPeriod &&
                                    <p className="red-text">Geselecteerd: Niets geselecteerd</p>}
                                <DatePicker
                                    selected={this.state.endPeriodValue}
                                    onChange={(date: Date) => {
                                        this.setState({endPeriodValue: date})
                                        this.handleChange('beheereenheid_end')
                                    }}
                                    dateFormat='dd/MM/yyyy'
                                    className="form-control"
                                    id={"beheereenheid_end"}
                                    placeholderText={'Horizon Einde'}
                                />
                                <br/>
                                <br/>
                                <h1>Maatregel :</h1>
                                {this.state.warnMeasures &&
                                    <p className="red-text">Geselecteerd: Niets geselecteerd</p>}
                                <input
                                    id="maatregel-zoeken-input"
                                    type="search"
                                    className="modal-search"
                                    placeholder="Zoeken"
                                    onChange={(e) => this.handleChange(e)}
                                />
                                <div className="modal-scroll">
                                    <div id="maatregel-grp-maintenance" className="radio-grp"/>
                                </div>
                                <br/>
                                <h1>Werkplan :</h1>
                                {this.state.warnWorkPlan &&
                                    <p className="red-text">Geselecteerd: Niets geselecteerd</p>}
                                <input
                                    id="werkplan-zoeken-input"
                                    type="search"
                                    className="modal-search"
                                    placeholder="Zoeken"
                                    autocomplete="off"
                                    onChange={(e) => this.handleChange(e)}
                                />
                                <div className="modal-scroll">
                                    <div id="werkplan-grp" className="radio-grp"/>
                                </div>
                                {/*<br/>*/}
                                {/*<h1>Budget :</h1>*/}
                                {/*{this.state.warnBudget && <p className="red-text">Geselecteerd: Niets geselecteerd</p>}*/}
                                {/*<input*/}
                                {/*    id="budget-zoeken-input"*/}
                                {/*    type="search"*/}
                                {/*    className="modal-search"*/}
                                {/*    placeholder="Zoeken"*/}
                                {/*    autocomplete="off"*/}
                                {/*    onChange={(e) => this.handleChange(e)}*/}
                                {/*/>*/}
                                {/*<div className="modal-scroll">*/}
                                {/*    <div id="budget-grp" className="radio-grp"/>*/}
                                {/*</div>*/}
                                <h1>Organisatie :</h1>
                                {this.state.warnOrganisation &&
                                    <p className="red-text">Geselecteerd: Niets geselecteerd</p>}
                                <input
                                    id="organisatie-zoeken-input"
                                    type="search"
                                    className="modal-search"
                                    placeholder="Zoeken"
                                    autocomplete="off"
                                    onChange={(e) => this.handleChange(e)}
                                />
                                <div className="modal-scroll">
                                    <div id="organisatie-grp" className="radio-grp"/>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn-modal"
                                onClick={this.handleBeforeSubmit.bind(this)}
                                disabled={this.state.disableButton}
                            >
                                Verwerken
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CorrectiefOnderhoud;
